import Dialog from "../../dialog/Dialog";
import { useState, useEffect } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Toster from "../../common/Toster";
import {
  STATUS_DIALOG_WIDTH,
  StatusApprovalSection,
  StatusSettingsBody,
  StatusToggleRow,
} from "../../common/StatusSettingsParts";
import { eventSettings } from "./service";

const EventSettings = ({ open, onClose, eventData }) => {
  const [showToster, setShowToster] = useState(false);
  const queryClient = useQueryClient();
  const [status, setStatus] = useState({
    popular: eventData?.popular || 0,
    is_approved: eventData?.is_approved || 0,
    is_active: eventData?.is_active || 1,
    recommended: eventData?.recommended || 0,
  });

  useEffect(() => {
    if (!open || !eventData) return;
    setStatus({
      popular: eventData?.popular || 0,
      is_approved: eventData?.is_approved ?? 0,
      is_active: eventData?.is_active ?? 1,
      recommended: eventData?.recommended || 0,
    });
  }, [open, eventData]);

  const handleToggle = (field) => {
    setStatus((prev) => ({
      ...prev,
      [field]: prev[field] === 1 ? 0 : 1,
    }));
  };

  const updateEventSettingsMutation = useMutation({
    mutationFn: () => eventSettings(eventData.id, status),
    onSuccess: () => {
      queryClient.invalidateQueries(["events"]);
      setShowToster({
        message: "Event settings updated successfully",
        type: "success",
        show: true,
      });
      onClose();
    },
    onError: (error) => {
      setShowToster({
        message: error.message || "Failed to update event settings",
        type: "error",
        show: true,
      });
    },
  });

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        title="Event Status"
        width={STATUS_DIALOG_WIDTH}
        primaryButtonText="Save Changes"
        primaryButtonAction={() => updateEventSettingsMutation.mutate()}
        isLoading={updateEventSettingsMutation.isPending}
      >
        <StatusSettingsBody>
          <StatusToggleRow
            title="Popular Event"
            description="Show this event as popular"
            checked={status.popular === 1}
            onChange={() => handleToggle("popular")}
          />
          <StatusToggleRow
            title="Explore World Recommended"
            description="Mark this event as recommended by Explore World"
            checked={status.recommended === 1}
            onChange={() => handleToggle("recommended")}
          />
          <StatusApprovalSection
            value={status.is_approved}
            onChange={(value) =>
              setStatus((prev) => ({ ...prev, is_approved: value }))
            }
            description="Set the approval status for this event"
          />
          <StatusToggleRow
            title="Active Status"
            description="Event is active and visible to users"
            checked={status.is_active === 1}
            onChange={() => handleToggle("is_active")}
          />
        </StatusSettingsBody>
      </Dialog>
      {showToster && (
        <Toster
          message={showToster.message}
          type={showToster.type}
          onClose={() => setShowToster(false)}
        />
      )}
    </>
  );
};

export default EventSettings;
